import { GetterTree } from "vuex";
import { ScoreState } from "../types";
import { IRootState, IRootGetters } from "../../types";
import {
  UnitAndCalories,
  UnitsAndCaloriesPerDay,
  emptyUnitAndCalories
} from "@dcc/types/drinkingDay";
import { getDailyUnitsAndCalories } from "@dcc/score/daily";
import { getCaloriesAndUnitsPerDay } from "../getterRules/caloriesAndUnitsPerDay";
import { IScoreGetters } from "./types";
import { GetterNames } from "./names";

export const getters: GetterTree<ScoreState, IRootState> = {
  [GetterNames.CALORIESANDUNITSFOREACHDAY](
    state: ScoreState,
    getters: IScoreGetters,
    rootState: IRootState,
    rootGetters: IRootGetters
  ): UnitsAndCaloriesPerDay[] {
    const days = rootGetters["drinking/actualDrinkingDays"];
    const gender = rootGetters["profile/gender"];
    const targetPercentage = rootGetters["drinking/targetPercentage"];
    return getCaloriesAndUnitsPerDay({
      days,
      gender,
      targetPercentage
    });
  },
  [GetterNames.ORIGINALCALORIESANDUNITSFOREACHDAY](
    state: ScoreState,
    getters: IScoreGetters,
    rootState: IRootState,
    rootGetters: IRootGetters
  ): UnitsAndCaloriesPerDay[] {
    const days = rootGetters["drinking/originalDrinkingDays"];
    const gender = rootGetters["profile/gender"];
    return getCaloriesAndUnitsPerDay({
      days,
      gender,
      targetPercentage: undefined
    });
  },

  [GetterNames.DAILYUNITSANDCALORIES](
    state: ScoreState,
    getters: IScoreGetters,
    rootState: IRootState,
    rootGetters: IRootGetters
  ): UnitAndCalories {
    const drinkFrequency = rootGetters["drinking/drinkFrequency"];
    const totalWeeklyUnitsAndCalories =
      getters[GetterNames.WEEKLYUNITSANDCALORIES];
    const days = rootGetters["drinking/actualDrinkingDays"];
    const numberOfMonthlyDrinkingDays =
      rootGetters["drinking/monthlyDrinkingDays"];

    return drinkFrequency
      ? getDailyUnitsAndCalories({
          drinkFrequency,
          totalWeeklyUnitsAndCalories,
          numberOfWeeklyDrinkingDays: days.length,
          numberOfMonthlyDrinkingDays
        })
      : emptyUnitAndCalories;
  }
};
